module.exports = __webpack_public_path__ + "static/hill_back_right_albedo-f3e195211f4f0a619ac845a014762e97.png";